import type { Notification } from '@parlay-picker/shared/notification';
import type { NotificationDisplayData } from '@parlay-picker/shared/notificationDisplay';
import type { ReactElement } from 'react';
import { FallbackBody } from './FallbackBody';

/** Social body: actor avatar + bold name + summary + odds */
export function SocialBody({
  displayData,
  notification,
}: {
  displayData: NotificationDisplayData;
  notification: Notification;
}): ReactElement {
  const { social } = displayData;
  if (!social) return <FallbackBody notification={notification} />;

  // Strip actor name from summary to avoid repetition
  const summaryWithoutActor = notification.data.summary
    .replace(social.actorDisplayName, '')
    .replace(/^\s+/, '');

  return (
    <div className="flex items-center gap-3 mt-2">
      <img
        src={social.actorAvatarUrl}
        alt={social.actorDisplayName}
        className="w-9 h-9 rounded-full shrink-0 ring-2 ring-theme-border/50"
      />
      <div className="flex-1 min-w-0">
        <p className="text-sm text-theme-text leading-snug">
          <span className="font-bold">{social.actorDisplayName}</span> {summaryWithoutActor}
        </p>
        {social.oddsFormatted && (
          <span className="inline-block mt-1 font-mono text-xs font-bold px-2 py-0.5 rounded bg-theme-success/15 text-theme-success">
            {social.oddsFormatted}
          </span>
        )}
      </div>
    </div>
  );
}
